import { requiredValidator } from './simpleValidators';
import { PROMISE_OK } from '../const';

export const automaticRequiredValidator = (automatic: boolean, value: any) => {
    if (automatic) {
        return requiredValidator(value);
    }
    return Promise.resolve(PROMISE_OK);
};
